import React from 'react';
import { Dialog, DialogContent, CircularProgress, Typography, Box } from '@mui/material';

const SpinnerModal = ({
  open,
  progress,
  inProgressMessage,
  successMessage,
  onClose,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogContent sx={{ textAlign: 'center', padding: 4 }}>
      {progress < 100 ? (
        <>
          <CircularProgress />
          <Typography variant="h6" sx={{ marginTop: 2 }}>
            {inProgressMessage}
          </Typography>
          <Typography variant="body1" sx={{ marginTop: 1 }}>
            {progress}%
          </Typography>
        </>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <Box
            sx={{
              width: 60,
              height: 60,
              borderRadius: '50%',
              backgroundColor: 'green',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Typography variant="h4" sx={{ color: 'white' }}>✔</Typography>
          </Box>
          <Typography variant="h6" sx={{ marginTop: 2 }}>
            {successMessage}
          </Typography>
        </Box>
      )}
    </DialogContent>
  </Dialog>
);

export default SpinnerModal;